import { DropdownOption, ScoringFields } from '~src/model';

export const CREATING_OFFER_MESSAGE = `Deres tilbud er ved at blive oprettet og afsendt. Dette kan tage et øjeblik...`;

export const ADDITIONAL_INFORMATION_TITLE = `Hjælp os med at hjælpe dig – og få 2.000 kr. i rabat!`;

export const ADDITIONAL_INFORMATION_SUBTITLE = `Vi vil gerne give dig den bedst mulige service! Ved at svare på 6 hurtige spørgsmål hjælper du os med at forstå dine behov – og som tak får du 2.000 kr. i rabat, hvis du beslutter dig for at købe inden for de næste 30 dage.`;

export const ADDITIONAL_INFORMATION_BULLETPOINTS = [
  `Det tager under et minut`,
  `Det gør vores rådgivning mere præcis`,
  `Og hey… hvem siger nej til 2.000 kr. i rabat?`,
];

export const ADDITIONAL_INFORMATION_DISCLAIMER = `OBS! Rabatten kan ikke kombineres med andre tilbud.`;

export const ADDITIONAL_INFORMATION_INCENTIVE = `Udfylde skemaet nu – eller springe over (Men helt ærligt… hvorfor skulle du dog gøre det?)`;

export const ADDITIONAL_INFORMATION_QUESTIONS: {
  value: keyof ScoringFields;
  label: string;
  options: DropdownOption[];
}[] = [
  {
    value: 'referencedBy',
    label: `Hvor har du hørt om Bodil Energy?`,
    options: [
      { label: 'Gennem en af vores partnere', value: 'partner' },
      { label: 'Gennem Instagram eller Facebook', value: 'meta' },
      { label: 'Gennem Google', value: 'google' },
      { label: 'Gennem mund-til-mund', value: 'wordOfMouth' },
      { label: 'Gennem TrustPilot', value: 'trustPilot' },
      { label: 'Andet', value: 'other' },
    ],
  },
  {
    value: 'investmentTime',
    label: `Overvejer du at investere inden for 3 måneder?`,
    options: [
      { label: 'Ja', value: 'within3Months' },
      { label: 'Nej', value: 'laterThan3Months' },
      { label: 'Jeg undersøger bare mulighederne', value: 'undecided' },
    ],
  },
  {
    value: 'heatingSource',
    label: `Hvad er dit nuværende varmesystem?`,
    options: [
      { label: 'Gas', value: 'gas' },
      { label: 'Olie', value: 'oil' },
      { label: 'El', value: 'electricity' },
      { label: 'Fjernvarme', value: 'districtHeating' },
      { label: 'Varmepumpe', value: 'heatPump' },
      { label: 'Andet', value: 'other' },
    ],
  },
  {
    value: 'yearlyElectricityCost',
    label: `Hvor meget betaler du årligt for el?`,
    options: [
      { label: 'Under 4.000kr', value: 'lessThan4000' },
      { label: '4.000kr til 14.000kr', value: 'between4000and14000' },
      { label: 'Over 14.000kr', value: 'moreThan14000' },
      { label: 'Ved ikke', value: 'unknown' },
    ],
  },
  {
    value: 'yearlyHeatingCost',
    label: `Hvor meget betaler du årligt for varme?`,
    options: [
      { label: 'Under 15.000kr', value: 'lessThan15000' },
      { label: '15.000kr til 25.000kr', value: 'between15000and25000' },
      { label: 'Over 25.000kr', value: 'moreThan25000' },
      { label: 'Ved ikke', value: 'unknown' },
    ],
  },
  {
    value: 'residenceOwnership',
    label: `Ejer du boligen?`,
    options: [
      { label: 'Ja', value: 'owner' },
      { label: 'Nej, jeg lejer', value: 'renting' },
      { label: 'Nej, men jeg overvejer at købe', value: 'lookingToBuy' },
    ],
  },
];
